import { computed } from 'vue';
import { Features } from '@shared/features';
import { useAuthenticated } from '@othercommerce/foundation';

export function useCustomerOrderAbility() {
  const authenticated = useAuthenticated();

  return computed(() => {
    const customer = authenticated.value;

    if (Features.forceAuthenticatedAndAccepted.isEnabled) {
      return !!customer && !!customer.emailVerifiedAt && !!customer.acceptedAt;
    }

    if (Features.forceAuthenticated.isEnabled) {
      return !!customer && !!customer.emailVerifiedAt;
    }

    return true;
  });
}
